import {makeStyles, createStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => createStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    border: `none`
  },
  input: {
    flex: 1,
    background: 'transparent',
    padding: 0
  },
  iconButton: {
    padding: 10,
    borderRadius: `8px`,
    backgroundColor: theme.palette.primary.main,
    margin: '-1px',
    minWidth: 42,
    minHeight: 42
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

export default useStyles